import React from 'react'

const Thirty_six = () => {
    return (
        <div className='container'>
            <h1> Carry Out Swapping of Two Numbers in C</h1>
           
                <p>Swapping two number in C programming language means exchanging
                     the values of two variables. Suppose you have two variable var1
                      & var2. Value of var1 is 20 & value of var2 is 40. <br />
                      So, after swapping the value of var1 will become 40 & value of
                       var 2 will become 20. In this blog will understand how to swap 
                       two variables in C.</p>
            
            <h3>Swapping Two Numbers Using Third Variable</h3>
            
                <p>   Logic <br />
                    The idea behind swapping two numbers using 3rd variable is simple.
                     Store the value of 1st variable in temporary variable. Store 
                     the value of 2nd variable in the first variable. At last, store
                      the value of temp variable in 2nd variable. In this program, 
                      we are using a temporary variable to hold the value of the first
                       variable. <br />
                       <ol>
                           <li>Assign var1 value to a temp variable: temp = var1</li>
                           <li>Assign var2 value to var1: var1 = var2</li>
                           <li>Assign temp value to var2: var2 = temp</li>
                       </ol>
           </p> 
            <div className='containers'>
           <code className='library'>#include</code>  &lt;stdio.h &gt;<br/> 
           <code className='keywords'>int</code> main()
 &#123;<br/>
 <code className='keywords'>int</code> var1, var2, temp;<br/> 
 <code className='library'>printf</code>("Enter two integersn");<br/>
 <code className='library'>scanf</code>("%d%d", &var1, &var2);<br/>
 <code className='library'>printf</code>("Before SwappingnFirst variable = %dnSecond variable = %dn", var1, var2);<br/>
temp = var1;<br/>
var1 = var2;<br/>
var2 = temp;<br/>
<code className='keywords'>printf</code>("After SwappingnFirst variable = %dnSecond variable = %dn", var1, var2);<br/>
<code className='library'>return</code> 0;<br/>
&#125;<br/>
            </div>
            <h3>Swapping Two Numbers Using Without Using Third Variable</h3>
           <p>
            In this variation of swapping two variables, we are not using any temporary 
            variable to store the value. In the first variable we are storing the sum of 
            both variable. Then, in next step we are we are extracting the value of 1st 
            variable by subtracting the value of 2nd variable form the sum & storing it in 
            2nd variable. At last, we are extracting the original value of the 2nd variable
             & storing it in the 1st variable. <br />
           </p> 
            <div className='containers'>
            <code className='library'> #include</code> &lt;stdio.h &gt;<br/> 
            <code className='keywords'>int</code> main()
 &#123;<br/>
 <code className='keywords'>int</code> var1, var2;<br/> 
 <code className='library'>printf</code>("Enter two integersn");<br/>
 <code className='library'>scanf</code>("%d%d", &var1, &var2);<br/>
 <code className='library'> printf</code>("Before SwappingnFirst variable = %dnSecond variable = %dn", var1, var2);<br/>
var1 = var1+var2;<br/>
var2 = var1-var2;<br/>
var1 = var1-var2;<br/>
<code className='library'>printf</code>("After SwappingnFirst variable = %dnSecond variable = %dn", var1, var2);<br/>
<code className='library'>return </code>0;<br/>
&#125;<br/>
            </div>
        </div>
    )
}

export default Thirty_six
